// src/composables/useSnackbar.js
import { ref } from 'vue'

const snackbar = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref('success')

function showSnackbar(message, color = 'success') {
  snackbarMessage.value = message
  snackbarColor.value = color
  snackbar.value = true
}

export function useSnackbar() {
  return {
    snackbar,
    snackbarMessage,
    snackbarColor,
    showSnackbar
  }
}

/* EXEMPLE  D'US

<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  timeout="3000"
  multi-line
>
  {{ snackbarMessage }}
</v-snackbar>

<script setup>
import { useSnackbar } from '@/composables/useSnackbar'

const {
  snackbar,
  snackbarMessage,
  snackbarColor,
  showSnackbar
} = useSnackbar()

// Exemple d’ús:
showSnackbar('Client guardat correctament', 'success')
</script>

*/